import InfoTab from "../storageRoles/InfoTab";

export default function DealerRolesInfoTab({
  firm,
  onFirmUpdate,
  onSelectedFirm,
  onOpenReportSettings,
}) {
  return (
    <InfoTab
      firm={firm}
      readOnly={true}
      onFirmUpdate={onFirmUpdate}
      onSelectedFirm={onSelectedFirm}
      onOpenReportSettings={onOpenReportSettings}
    />
  );
}
